// extracted by mini-css-extract-plugin
export default {"printBtn":"PackageList_printBtn__ArPxJ","currentDateContainer":"PackageList_currentDateContainer__NTn5p","minTrunkCapacity":"PackageList_minTrunkCapacity__E5vuE"};